import React, { useEffect, useRef, useState } from "react";

import { Box, Card, CircularProgress, Grid, Typography } from "@mui/material";
import * as  d3 from "d3";
import { getSunburstData } from "./SunburstAPICall";
import { ControlPointSharp } from "@material-ui/icons";
import breadCrumbArrow from '../../assets/breadcum-arrow.svg';
import '../css/sunburst-breadcrumb.css';
import { useNavigate } from "react-router-dom";
import ModalDialog from "../ModalDialog";

const BreadcrumbTree = ({ steps }) => {
  const renderTree = (index = 0) => {
    if (index >= steps?.length) return null;

    const id = `node-${index}`;

    return (
      <ul className="tree">
        <li>
          <input type="checkbox" id={id} defaultChecked />
          <label className="tree_label" htmlFor={id}>{steps[index]}</label>
          {index + 1 < steps?.length && (
            <ul>
              <li>{renderTree(index + 1)}</li>
            </ul>
          )}
        </li>
      </ul>
    );
  };

  return <div>{renderTree()}</div>;
};
const SunburstChartD3Older = () => {
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const [data, setData] = useState();
  const [sunbrustLoader, setSunbrustLoader] = useState(false);
  const [breadcrumb, setBreadCrumb] = useState([])
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [activeDomain, setActiveDomain] = useState(null);
  useEffect(() => {
    setBreadCrumb([])
    getData()
  }, [])

  const getData = async () => {
    setSunbrustLoader(true);
    const response = await getSunburstData();
    if (response) {
      setData(response)
    }
    setSunbrustLoader(false);
  }


  const tooltip = d3.select("body")
    .append("div")
    .style("position", "absolute")
    .style("background", "rgba(0, 0, 0, 0.7)")
    .style("color", "white")
    .style("padding", "5px")
    .style("border-radius", "4px")
    .style("pointer-events", "none")
    .style("opacity", 0);


  const width = 1200;
  const height = width;
  const radius = width / 4;

  useEffect(() => {
    if (data) {
      // console.log("data", data);
      d3.select(chartRef.current).selectAll("*").remove();


      // Compute the layout.
      const hierarchy = d3
        .hierarchy(data)
        .sum(d => d.value)
        .sort((a, b) => b.value - a.value);

      const root = d3
        .partition()
        .size([2 * Math.PI, hierarchy.height + 1])
        (hierarchy);

      root.each(d => d.current = d);  // Maintain the current node reference for transition

      // Create the color scale.
      const numChildren = hierarchy?.children?.length ?? 0;
      const color = d3.scaleOrdinal(d3.quantize(d3.interpolateRainbow, numChildren + 1));
      // const color = d3.scaleOrdinal(d3.schemeCategory10);


      // Create the arc generator.
      const arc = (d3.arc()
        .startAngle(d => d.x0)
        .endAngle(d => d.x1)
        .padAngle(d => Math.min((d.x1 - d.x0) / 2, 0.005))
        .padRadius(radius * 1.5)
        .innerRadius(d => d.y0 * radius)
        .outerRadius(d => Math.max(d.y0 * radius, d.y1 * radius - 1)))

      // Create the SVG container.
      const svg = (d3
        .select(chartRef.current)
        .append("svg")
        .attr("viewBox", [-width / 2, -height / 2, width, width])
        .style("font", "10px sans-serif"));


      // Appending a circle for demonstration
      svg.append("circle")
        .attr("r", radius)
        .attr("fill", "lightblue")
        .attr("stroke", "black");


      ////provide colors
      //1. Interpolator from #2739b4 (blue) to #a1247e (pink)
      const interpolateThemeColor = d3.interpolateRgb("#2739b4", "#ff6ec7");

      // 2. Hash function to convert a string into a number between 0–1
      function nameToT(name) {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
          hash = name?.charCodeAt(i) + ((hash << 5) - hash);
        }
        // Make it positive and scale to [0, 1]
        return ((hash >>> 0) % 1000) / 1000;
      }

      // 3. Map of name -> color using deterministic hash
      const nameToColor = new Map();
      root.descendants()?.forEach(d => {
        const name = d.data?.name;
        if (!nameToColor?.has(name)) {
          const t = nameToT(name);
          nameToColor?.set(name, interpolateThemeColor(t));
        }
      });
      ///end color selection

      // Append the arcs.
      const path = (svg.append("g")
        .selectAll("path")
        .data(root.descendants().slice(1))
        .join("path")
        // .attr("fill", d => d.data.color ? d.data.color : color(d.data.name))
        .attr("fill", d => nameToColor.get(d.data.name || d.data.color))
        .attr("fill-opacity", d => arcVisible(d.current) ? (d.children ? 0.6 : 0.4) : 0)
        .attr("pointer-events", d => arcVisible(d.current) ? "auto" : "none")
        .attr("d", d => arc(d.current))
      );
      // Add Tooltip 
      path.on("mouseover", (event, d) => {

        tooltip.style("opacity", 1)
          .html(`
          ${d.data.name}
        `)
          .style("left", (event.pageX + 10) + "px")
          .style("top", (event.pageY + 10) + "px");
      })
        .on("mousemove", (event) => {
          tooltip.style("left", (event.pageX + 10) + "px")
            .style("top", (event.pageY + 10) + "px");
        })
        .on("mouseout", () => {
          tooltip.style("opacity", 0);
        });

      // Make them clickable if they have children.
      // path.filter(d => d.children)
      //   .style("cursor", "pointer")
      //   .on("click", clicked);

      path
        .on("click", (event, d) => {
          if (d.children) {
            clicked(event, d); // zoom behavior
          } else {
            let data = d.parent?.parent?.parent?.data
            let parent = d.parent.data;
            if (parent?.name === "Controls") {
              setActiveDomain(data?.domain);
              setOpenConfirmationModal(true);
            }
          }
        });

      const label = (svg.append("g")
        .attr("pointer-events", "none")
        .attr("text-anchor", "middle")
        .style("user-select", "none")
        .selectAll("text")
        .data(root.descendants().slice(1))
        .join("text")
        .attr("dy", "0.35em")
        .attr("fill-opacity", d => +labelVisible(d.current))
        .attr("transform", d => labelTransform(d.current))
        .attr("fill", "white")
        // .text(d => d.data.name.length > 15 ? `${d.data.name.slice(0, 15)}...` : d.data.name)
        .style("font-size", "26px")
        .each(function (d) {
          const rawWords = d?.data?.name?.split(/[\s-]/); // Split on spaces or hyphens
          const maxCharsPerLine = 20;
          const lines = [];
          let currentLine = "";

          rawWords.forEach((word, i) => {
            // Add hyphen back if the word came from a hyphen split
            const nextWord = word + ((/\w/?.test(word) && d?.data?.name?.includes(word + "-")) ? "-" : "");

            if ((currentLine + nextWord).length < maxCharsPerLine) {
              currentLine = currentLine + " " + nextWord;
            } else {
              if (currentLine) lines?.push(currentLine);
              currentLine = nextWord;
            }
          });

          if (currentLine) lines?.push(currentLine);

          d3.select(this)?.text(null); // Clear existing text

          lines?.forEach((line, i) => {
            d3.select(this)?.append("tspan")
              .attr("x", 0)
              .attr("dy", i === 0 ? "0em" : "1.1em")
              .text(line);
          });
        })
      );

      const parent = (
        svg.append("circle")
          .datum(root)
          .attr("r", radius)
          .attr("fill", "#120a3a")
          .attr("pointer-events", "all")
          .on("click", clicked)
      );

      svg.append("text")
        .attr("class", "center-title") // Add class for easier selection
        .attr("text-anchor", "middle")
        .attr("dy", "0.35em")
        .style("font-size", "30px")
        .style("fill", "white")
        .text("Third Party Ecosystem"); // Initial title for the root


      // Handle zoom on click.
      function clicked(event, p) {
        setBreadCrumb(prev => {
          if (p?.depth < prev?.length) {
            let newBreadCrumb = prev;
            newBreadCrumb.splice(-1)
            return [...newBreadCrumb];
          } else if (p?.depth) {
            const newBreadCrumb = [...prev, p?.data?.name];
            return newBreadCrumb;
          } else return prev;
        });

        parent.datum(p.parent || root);

        svg.select("text.center-title")
          .text(p.depth === 0 ? "Ecosystem" : p.data.name?.length > 30 ? `${p.data.name?.slice(0, 30)}...` : p.data?.name) // Update with depth or node name
          .attr("dy", "0.35em")
          .style("font-size", "30px")
          .style("fill", "white")
          .on("mouseover", () => {
            tooltip.style("opacity", 1)
              .html(`${p.data.name}`)
              .style("left", (event.pageX + 10) + "px")
              .style("top", (event.pageY + 10) + "px");
          })
          .on("mouseout", () => {
            tooltip.style("opacity", 0);
          });




        root.each(d => d.target = {
          x0: Math.max(0, Math.min(1, (d.x0 - p.x0) / (p.x1 - p.x0))) * 2 * Math.PI,
          x1: Math.max(0, Math.min(1, (d.x1 - p.x0) / (p.x1 - p.x0))) * 2 * Math.PI,
          y0: Math.max(0, d.y0 - p.depth),
          y1: Math.max(0, d.y1 - p.depth)
        });

        const t = svg.transition().duration(event.altKey ? 7500 : 750);

        // Transition the data on all arcs, even the ones that aren’t visible,
        // so that if this transition is interrupted, entering arcs will start
        // the next transition from the desired position.
        path.transition(t)
          .tween("data", d => {
            const i = d3.interpolate(d.current, d.target);
            return t => d.current = i(t);
          })
          .filter(function (d) {
            return +this.getAttribute("fill-opacity") || arcVisible(d.target);
          })
          .attr("fill-opacity", d => arcVisible(d.target) ? (d.children ? 0.6 : 0.4) : 0)
          .attr("pointer-events", d => arcVisible(d.target) ? "auto" : "none")

          .attrTween("d", d => () => arc(d.current));

        label.filter(function (d) {
          return +this.getAttribute("fill-opacity") || labelVisible(d.target);
        }).transition(t)
          .attr("fill-opacity", d => +labelVisible(d.target))
          .attrTween("transform", d => () => labelTransform(d.current));
      }


      function arcVisible(d) {
        return d.y1 <= 2 && d.y0 >= 1 && d.x1 > d.x0;
      }

      function labelVisible(d) {
        return d.y1 <= 2 && d.y0 >= 1 && (d.y1 - d.y0) * (d.x1 - d.x0) > 0.03;
      }

      function labelTransform(d) {
        const x = (d.x0 + d.x1) / 2 * 180 / Math.PI;
        const y = (d.y0 + d.y1) / 2 * radius;
        return `rotate(${x - 90}) translate(${y},0) rotate(${x < 180 ? 0 : 180})`;
      }
      return () => {
        // Clean up on unmount
        d3.select(chartRef.current).selectAll("*").remove();
        tooltip.remove();
      };
    }
  }, [data]);

  const confirmationModalContent = () => (
    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
      <h2 className="send-assessments">
        Are you sure you want to redirect to controls ?
      </h2>
    </Typography>
  )
  return (
    <>
      {(sunbrustLoader || data?.children.length > 0) &&
        <Grid item xs={12} md={12} className="left-fit-contain">
          <Card sx={{ mb: 1 }}>
            <div className="top-heading-dashboard">

              <h2>Ecosystem Navigator</h2>
              <Box sx={{ margin: "20px 0px" }}>
                {sunbrustLoader ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "295px",
                      width: "100%",
                    }}
                  >
                    <CircularProgress className="loader-custom-class-new" />
                  </Box>
                ) : (
                  <>
                    {/* <Box sx={{marginLeft: "40px"}}><BreadcrumbTree steps={breadcrumb} /></Box> */}
                    <div className="sunburst-breadcrumb">{breadcrumb?.length ? breadcrumb?.map((item, i) => (
                      <span>
                        {item}
                        {i < breadcrumb?.length - 1 ? <img src={breadCrumbArrow} alt="" /> : null}
                      </span>)) : null}
                    </div>
                    <div ref={chartRef} style={{ width: "44%", height: "auto", margin: "0px auto" }}></div>
                  </>
                )}
              </Box>

            </div>
          </Card>
        </Grid>
      }
      <ModalDialog
        handleClose={() => { setOpenConfirmationModal(false); setActiveDomain(null) }}
        open={openConfirmationModal}
        contentData={confirmationModalContent()}
        onSubmit={() => navigate(`/dashboard/vendorDetails/${activeDomain}`, { state: { mainTabValue: 4 } })}
      />
    </>
  )
}
export default SunburstChartD3Older;
